



















    import Vue from 'Vue';
    import Vuex from 'Vuex';
    export default Vue.extend({
        name: 'application-side-panel',
        props: { contentClass: String, position: String, id: { type: String, required: true } },
        methods: {
            expandoClicked ():void {
                this.$store.commit('ui/setAppPanelVisible', !this.show);
                if (!this.show)
                    this.$store.dispatch('extensions/activateDefault', true);
                else
                    this.$store.dispatch('extensions/activateCurrent');
                this.$emit('expandoClicked', { show: this.show });
            },
            transitionCompleteHandler(): void {
                this.$emit('transitionComplete', { show: this.show });
            }
        },
        mounted: function () {
            this.$nextTick(function () { //all the dom elements will be available now so create the map
                var el = document.getElementById(this.id + '_content');
                if(el)
                    el.addEventListener('transitionend', this.transitionCompleteHandler.bind(this), true);
            });
        },
        computed: {
            show(): boolean {
                return this.$store.state.ui.appPanelVisible;
            },
            positionClass(): boolean {
                var retVal = null;
                if (this.position === 'left') {
                    retVal = { 'widget-pane-left-toggle-button-container': true };
                }
                else {
                    retVal = { 'widget-pane-right-toggle-button-container': true };
                }
                return retVal;
            },
            expandoClass(): any {
                var retVal = { 'widgetPaneCollapsed': this.show };
                if (this.position === 'left') {
                    retVal = { 'widgetPaneCollapsed': this.show ? false : true };
                }
                else {
                    retVal = { 'widgetPaneCollapsed': this.show ? true : false };
                }
                return retVal;
            },
            contentCss(): string {
                return this.contentClass;
            },
            contentId(): string {
                return this.id + '_content';
            },
            isMobile(): boolean {
                return this.$vuetify.breakpoint.mobile;
            },
            showParent(): boolean {
                let show = true;
                if (this.isMobile)
                    show = this.show;
                return show;
            }

        }
    });
